import { render, staticRenderFns } from "./interfacemaintenancelist.vue?vue&type=template&id=0abaf7ee"
import script from "./interfacemaintenancelist.vue?vue&type=script&lang=js"
export * from "./interfacemaintenancelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports